import { IDrawerStyles, useDrawerStyles } from '..';
import Drawer, { DrawerProps } from '../drawer';
import { DrawerTemplateHeader, DrawerActionButtonProps, DrawerTemplateFooter } from './template';

export interface DrawerStyledProps extends DrawerProps {
    title?: string;
    headerbuttons?: DrawerActionButtonProps[]
    footerbuttons?: DrawerActionButtonProps[]
}

const ComponentProps = (props: DrawerStyledProps): DrawerProps => {
    const componentProps = Object.assign({}, props);
    delete componentProps.title;
    delete componentProps.headerbuttons;
    delete componentProps.footerbuttons;
        
    return componentProps;
}

export const DrawerStyled: React.FC<DrawerStyledProps> = (props) => {
    const styles: IDrawerStyles = useDrawerStyles();

    return (
        <Drawer {...ComponentProps(props)}  >
            <DrawerTemplateHeader title={props.title} buttons={props.headerbuttons} controlStyles={styles} />
            <Drawer.Body controlStyles={styles}>
                {props.children}
            </Drawer.Body>
            <DrawerTemplateFooter buttons={props.footerbuttons} controlStyles={styles} />
        </Drawer>
    );
};